import { Component, Input } from '@angular/core';
import { Vehicle } from '@app/shared/models/vehicle';
import { UpdateComponent } from '@app/shared/components/base/update.component';

@Component({
  selector: 'kba-input',
  templateUrl: './kba.component.html',
  styleUrls: ['./kba.component.scss']
})
export class KbaComponent extends UpdateComponent {

  @Input()
  public vehicle: Vehicle;

  constructor() {
    super();
  }

}
